/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  GetReceivedFollowRequestsQueryResponse,
  GetReceivedFollowRequests401,
} from "../types/GetReceivedFollowRequests.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { getReceivedFollowRequests } from "../client/getReceivedFollowRequests.ts"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getReceivedFollowRequestsQueryKey = () =>
  [{ url: "/follow-requests/received" }] as const

export type GetReceivedFollowRequestsQueryKey = ReturnType<
  typeof getReceivedFollowRequestsQueryKey
>

export function getReceivedFollowRequestsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getReceivedFollowRequestsQueryKey()
  return queryOptions<
    GetReceivedFollowRequestsQueryResponse,
    ResponseErrorConfig<GetReceivedFollowRequests401>,
    GetReceivedFollowRequestsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getReceivedFollowRequests(config)
    },
  })
}

/**
 * @summary Get pending follow requests for the current user
 * {@link /follow-requests/received}
 */
export function useGetReceivedFollowRequests<
  TData = GetReceivedFollowRequestsQueryResponse,
  TQueryData = GetReceivedFollowRequestsQueryResponse,
  TQueryKey extends QueryKey = GetReceivedFollowRequestsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetReceivedFollowRequestsQueryResponse,
        ResponseErrorConfig<GetReceivedFollowRequests401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getReceivedFollowRequestsQueryKey()

  const query = useQuery(
    {
      ...getReceivedFollowRequestsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetReceivedFollowRequests401>
  > & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}
